import { CLOSE_DEAL } from './closeDeal';
import { REOPEN_DEAL } from './reopenDeal';
import { UPDATE_DEAL_CLOSURE } from './updateDealClosure';

export const dealLifeCycleApi = {
  closeDeal: CLOSE_DEAL,
  reopenDeal: REOPEN_DEAL,
  updateDealClosure: UPDATE_DEAL_CLOSURE,
};

export * from './types';
export * from './useDealLifeCycle';
